function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "12pt",
    height: "15pt",
    viewBox: "0 0 12 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 9.601562 2.101562 C 9.601562 2.101562 10.5 1.300781 10.898438 0.898438 C 11.101562 0.699219 11.398438 0.699219 11.5 0.800781 C 11.699219 0.898438 11.699219 1.199219 11.601562 1.398438 C 11.601562 1.5 11.5 1.5 11.398438 1.601562 C 9.800781 3.300781 8.101562 5.101562 6.398438 6.800781 C 4.800781 8.398438 3.199219 10 1.601562 11.5 C 1.601562 11.5 1.5 11.601562 1.5 11.601562 C 1.300781 11.800781 1 11.800781 0.800781 11.601562 C 0.601562 11.398438 0.601562 11.101562 0.800781 10.898438 C 1.199219 10.5 1.5 10.101562 1.898438 9.800781 C 2.101562 9.699219 2.101562 9.601562 2 9.398438 C 1.5 8.5 1 7.601562 0.898438 6.601562 C 0.601562 5 1.101562 3.699219 2 2.5 C 3.398438 0.699219 5.898438 0 7.898438 0.898438 C 8.5 1.101562 9.398438 1.898438 9.398438 1.898438 Z M 5.199219 6.601562 C 5.800781 6 6.398438 5.398438 7 4.800781 C 7 4.800781 7 4.699219 7.101562 4.699219 C 6.800781 4.300781 6.300781 4.101562 5.800781 4.199219 C 5.199219 4.300781 4.800781 4.699219 4.699219 5.300781 C 4.601562 5.800781 4.800781 6.300781 5.199219 6.601562 Z M 5.199219 6.601562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6 13.199219 C 6.101562 13 6.300781 12.898438 6.398438 12.699219 C 7.398438 11.398438 8.5 10.101562 9.300781 8.699219 C 9.800781 7.800781 10.199219 6.898438 10.199219 5.898438 C 10.199219 5.398438 10.101562 4.898438 10 4.398438 C 9.898438 4 10 3.800781 10.199219 3.699219 C 10.5 3.601562 10.699219 3.699219 10.898438 4 C 11.199219 4.898438 11.300781 5.699219 11.101562 6.601562 C 10.800781 7.800781 10.199219 8.898438 9.601562 10 C 8.699219 11.398438 7.699219 12.800781 6.601562 14 C 6.300781 14.398438 6 14.398438 5.601562 14 C 4.898438 13.101562 4.101562 12.199219 3.398438 11.300781 C 3.398438 11.300781 3.398438 11.199219 3.300781 11.199219 C 3.101562 10.898438 3.199219 10.601562 3.398438 10.5 C 3.601562 10.300781 3.898438 10.398438 4.101562 10.699219 C 4.300781 11 4.601562 11.300781 4.800781 11.699219 C 5.199219 12.199219 5.601562 12.699219 6 13.199219 Z M 6 13.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 9.800781 2.300781 L 10.101562 2.5 L 10 2.5 L 10.101562 2.5 L 9.699219 2.5 Z M 9.800781 2.300781 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLocation);
export default __webpack_public_path__ + "static/media/noLocation.7feddcf9a71fa0e80e25324f4a6bdad9.svg";
export { ForwardRef as ReactComponent };